const SKELETON_ROWS = Array.from({ length: 3 });

export function TopUpCardSkeleton() {
  return (
    <div className="space-y-3">
      {SKELETON_ROWS.map((_, i) => (
        <div key={i} className="animate-pulse rounded-xl p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-lg bg-gray-200" />
              <div className="space-y-2">
                <div className="h-4 w-28 rounded bg-gray-200" />
                <div className="h-3 w-20 rounded bg-gray-200" />
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="h-4 w-16 rounded bg-gray-200" />
              <div className="h-5 w-20 rounded-full bg-gray-200" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
